import { useTranslation } from 'react-i18next';
import { useNotify } from '@hotjar/webapp/hooks/useNotify';
import type { UIPosition } from '@hotjar/webapp/domains/highlights/api';
import { useSetHighlightStatus } from './use-set-highlight-status';

export function useSetHighlightSolved(siteId: string): {
  setHighlightSolved: (highlightId: string, solved: boolean, uiPosition?: UIPosition) => void;
} {
  const { t } = useTranslation();
  const { success, error } = useNotify();
  const { mutateAsync: setHighlightSolvedStatus } = useSetHighlightStatus(siteId);

  const setHighlightSolved = async (
    highlightId: string,
    solved: boolean,
    uiPosition?: UIPosition,
  ) => {
    try {
      await setHighlightSolvedStatus({
        highlightId,
        solved,
        uiPosition,
      });

      success(
        solved
          ? t('highlights:single.mark_solved_success')
          : t('highlights:single.unmark_solved_success'),
      );
    } catch (er) {
      error(
        solved
          ? t('highlights:single.mark_solved_error')
          : t('highlights:single.unmark_solved_error'),
      );
    }
  };

  return { setHighlightSolved };
}
